import { Link } from "react-router-dom";
import { Play, Lock } from "lucide-react";
import { resolveAssetUrl } from "../lib/api";

function bgStyle(series) {
  if (series.banner_url) {
    return {
      backgroundImage: `url("${resolveAssetUrl(series.banner_url)}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundColor: series.color,
    };
  }
  return { background: series.color };
}

function CardInner({ series }) {
  return (
    <div className="group relative bg-white border-4 border-slate-900 rounded-2xl overflow-hidden shadow-brutal hover-press">
      <div className="aspect-[3/4] overflow-hidden border-b-4 border-slate-900 relative" style={bgStyle(series)}>
        <img
          src={resolveAssetUrl(series.poster_url)}
          alt={series.title}
          loading="lazy"
          className={`w-full h-full object-cover transition-transform duration-500 ${series.is_blocked ? "grayscale brightness-50" : "group-hover:scale-105"}`}
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
        <div className="absolute top-2 left-2 bg-yellow-300 border-2 border-slate-900 rounded-full px-3 py-0.5 text-xs font-black">
          {series.year}
        </div>
        <div className="absolute top-2 right-2 bg-slate-900 text-white rounded-full px-3 py-0.5 text-[10px] font-bold uppercase tracking-wider">
          {series.network}
        </div>

        {series.is_blocked ? (
          /* "Coming soon" overlay — retro style */
          <div className="absolute inset-0 flex items-center justify-center bg-slate-900/70 backdrop-blur-[2px]">
            <div className="text-center px-3">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-300 border-4 border-slate-900 shadow-brutal-sm mb-2 -rotate-6">
                <Lock className="w-5 h-5 text-slate-900" strokeWidth={3} />
              </div>
              <div className="font-pixel text-yellow-300 text-2xl leading-tight text-bubble-sm">
                ÎN CURÂND!
              </div>
              <div className="font-display font-black text-white text-sm leading-snug mt-2 text-bubble-sm">
                Pregătim desenul<br />pentru voi
              </div>
            </div>
          </div>
        ) : (
          /* Hover Play overlay */
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-slate-900/40">
            <div className="bg-pink-500 border-4 border-white rounded-full p-4 shadow-brutal-sm">
              <Play className="w-8 h-8 text-white fill-white" strokeWidth={3} />
            </div>
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="font-display font-black text-lg leading-tight line-clamp-2 text-lime-400 text-bubble-sm">
          {series.title}
        </div>
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider mt-1">
          {series.is_blocked ? "Indisponibil momentan" : series.network}
        </div>
      </div>
    </div>
  );
}

export default function SeriesCard({ series, index = 0 }) {
  const animation = {
    animationDelay: `${(index % 8) * 60}ms`,
  };

  if (series.is_blocked) {
    return (
      <div
        data-testid={`series-card-${series.id}`}
        className="block animate-pop-in cursor-not-allowed select-none"
        aria-disabled
        style={animation}
        title="Pregătim desenul pentru voi"
      >
        <CardInner series={series} />
      </div>
    );
  }

  return (
    <Link
      to={`/seriale/${series.id}`}
      data-testid={`series-card-${series.id}`}
      className="block animate-pop-in"
      style={animation}
    >
      <CardInner series={series} />
    </Link>
  );
}
